<template>
  <div class="account-auth-form-content">
    <div class="old-mb-4">
      <ValidationProvider
        name="first name"
        rules="required|alpha_dash"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          name="customer[first_name]"
          type="text"
          v-model="firstName"
          label="First Name"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
    </div>
    <div class="old-mb-4">
      <ValidationProvider
        name="last name"
        rules="required|alpha_dash"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          name="customer[last_name]"
          type="text"
          v-model="lastName"
          label="Last Name"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
    </div>
    <div class="old-mb-4">
      <ValidationProvider
        name="email"
        rules="required|email"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          name="customer[email]"
          type="email"
          v-model="email"
          label="Email"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
    </div>
    <div class="old-mb-6">
      <ValidationProvider
        name="password"
        rules="required|min:6"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          name="customer[password]"
          type="password"
          v-model="password"
          label="Password"
          :error="errors && errors[0]"
        />
      </ValidationProvider>

      <div class="mt-6 flex text-left align-top">
        <input type="hidden" name="customer[accepts_marketing]" value="false" />

        <input
          type="checkbox"
          name="customer[accepts_marketing]"
          class="mt-1 h-5 w-5 shrink-0"
          id="accepts-marketing"
          :checked="window.Shopify?.country === 'US'"
        />
        <label for="accepts-marketing" class="ml-4 text-sm leading-5"
          >Sign up to be the first to know about new collections, special
          events, promotions, and what’s going on at Our Place. You may
          unsubscribe at any time.</label
        >
      </div>
    </div>

    <div
      class="account-auth-terms mb-4 font-calibre text-xs leading-4 antialiased"
    >
      By creating an account, you will be signed up for our Dirty Dishes Club,
      and are acknowledging that you have reviewed and accepted our
      <a href="/pages/terms" target="_blank">Terms of Service</a>,
      <a
        href="/pages/program-specific-terms#dirty-dishes-club-terms"
        target="_blank"
      >
        Dirty Dishes Club Terms and Conditions
      </a>
      and <a href="/policies/privacy-policy" target="_blank">Privacy Policy</a>.
    </div>
    <input
      class="submit-button plaid-l fs-12"
      type="submit"
      value="CREATE ACCOUNT"
    />
  </div>
</template>

<script>
export default {
  name: "register-form",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
    };
  },
};
</script>
